<template>
  <div>
    <sgheader :newslist='newslist' @tabnewsindex='tabnewsindex'></sgheader>
    <section class='mains' :xs="24" :sm="24" :md="24" :lg="12" :style='{ height: contentHeight + "px" }'>
      <sgnav></sgnav>
      <!-- <section class='beContent' style='margin-left:260px;flex:auto;overflow: scroll;'> -->
      <router-view style='margin-left:230px;flex:auto;position:relative;zIndex:10;background:#fff;'
        :fromheadschoolid='curSchoolid' @refreshnews='refreshnews' :tabnindex='tabnindex' />
      <!-- </section> -->

      <!-- padding:20px 0px 0px 20px;flex:1; padding-right:0px; -->
      <!-- <Select v-model="schoolItem" class='schoolSelect' clearable filterable @on-change='changeSchool'
				v-if='schoolList.length>1'>
				<Option v-for="item in schoolList" :value="item.id" :key="item.id">{{ item.name }}</Option>
			</Select> -->
    </section>
  </div>
</template>

<script>
import sgheader from './sgheader.vue'
import sgnav from './sgnav'
export default {
  name: 'sgcontent',
  components: {
    sgheader,
    sgnav
  },
  mounted () {

    var that = this
    this.contentHeight = document.documentElement.clientHeight

    // utils.getSchoolData().then(res => {
    // 	var _data = JSON.parse(res)
    // 	that.schoolList = _data
    // 	that.schoolItem = Number(localStorage.getItem('curSchoolid')) || _data[0]['id']
    // 	localStorage.setItem('curSchoolid', that.schoolItem)
    // })

    // $('#mans').niceScroll({
    //     cursorcolor: "#ccc",//#CC0071 光标颜色
    //     cursoropacitymax: 1, //改变不透明度非常光标处于活动状态（scrollabar“可见”状态），范围从1到0
    //     touchbehavior: false, //使光标拖动滚动像在台式电脑触摸设备
    //     cursorwidth: "5px", //像素光标的宽度
    //     cursorborder: "0", // 	游标边框css定义
    //     cursorborderradius: "5px",//以像素为光标边界半径
    //     autohidemode: false //是否隐藏滚动条
    // });
    // this.axios.get('sysMenu/getMenuTree',{}).then(res=>{
    //   console.log(res,'sysMenu/getMenuTree')
    // })





  },
  data () {
    return {
      visible: false,
      theme1: 'light',
      theme3: 'light',
      curIndex: 1,
      contentHeight: 120,
      schoolList: [],
      schoolItem: '',
      curSchoolid: -1,
      newslist: [],
      tabnindex: {},
    }
  },
  methods: {
    tabnewsindex (e) {
      this.tabnindex = { idx: e, rnum: Math.random() }
    },
    refreshnews (data) {
      this.newslist = data
    },
    changeSchool (e) {

      localStorage.setItem('curSchoolid', e)
      this.curSchoolid = e
      // this.$emit('changeSchoolInfo',e)
    },
    changeSchoolInfo (val) {

      this.curSchoolid = val
    },
    show: function () {
      this.visible = true;
    },
    changeNavItem: function (e) {

      this.curIndex = e
    },
  }
}
</script>

<style scoped>
.crossLine {
  height: 3px;
  background: #f1f3f4;
  margin-left: 35px;
  margin-right: 35px;
  margin-top: 10px;
}

.lineLine {
  width: 2px;
  background: #f1f3f4;
  height: 300px;
  position: absolute;
  right: 0px;
  top: 120px;
  z-index: 1000;
}

.nav {
  position: relative;
  overflow: visible;
}

.mains {
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
  padding-top: 60px;
  position: relative;
  /* background: rgb(241, 243, 244); */
}

>>>.ivu-select-visible .ivu-select-selection {
  box-shadow: 0 0 0 0
}

.schoolSelect {
  position: absolute;
  left: 5px;
  bottom: 20px;
  width: 240px !important;
}

>>>.schoolSelect .ivu-select-selection {
  border: 0 none;

}

>>>.schoolSelect .ivu-select-dropdown {
  min-width: 1000px !important;
  left: 30px !important;
  z-index: 1000;
}

>>>.ivu-select-single .ivu-select-input {
  text-align: center;
}

.schoolSelect .ivu-select-dropdown-list .ivu-select-item {
  display: inline-block !important;
  float: left !important;
  clear: none !important;
  min-width: 240px;
}
</style>
